import React, { useState, useRef, useEffect } from "react";
import { FaBars} from "react-icons/fa";
import { Box, Button, Flex } from "pancakeswap-uikit";
import Sidebar from "./Sidebar";
import './Sidebar.css';

const logoHeight = "42px";

export const SideNav: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const overlay = useRef<HTMLDivElement>(null);
  const chainId  = 40;

  const mediaQueryStyle = {
    '@media screen and (max-width: 600px)': {
      display: 'none'
    }}

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (overlay.current && !overlay.current.contains(event.target as Node)) {
        setIsVisible(false);
      }
    };
    if (isVisible) {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      // Cleanup listener
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isVisible]); 

  if (!isVisible) {
    return (
      <div>
        {/* Button will be displayed for screen sizes less than 600px */}
        <div className="button-container">
          <FaBars onClick={() => setIsVisible(true)} style={{ cursor: 'pointer', paddingTop: '5px', paddingLeft: '10px', color: 'dark grey' }} size={30} />
        </div>
        <div className="overlay-container">
          <Sidebar chainId={chainId} />
        </div>
      </div>
    );
  }
  return (
    <>
      <div>
        <div ref={overlay}>
          <Sidebar chainId={chainId} />
        </div>
      </div>
    </>
  );
};